"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var getComponentName_1 = require("@helpscout/react-utils/dist/getComponentName");

var hoistNonReactStatics_1 = require("@helpscout/react-utils/dist/hoistNonReactStatics");

var Context_1 = require("./Context");

var utils_1 = require("./utils");

var classNames_1 = require("../../utilities/classNames");

var component_1 = require("../../utilities/component");

var is_1 = require("../../utilities/is");

var defaultOptions = {
  pure: true
};
/**
 * "Connects" a component with the PropProvider (context). Concept is
 * similar to Redux's connect higher-order function.
 *
 * @param   {string} name The component's config namespace.
 * @returns {React.Component} The connected React component.
 */

function propConnect(name, options) {
  if (options === void 0) {
    options = {};
  }

  var pure = __assign({}, defaultOptions, options).pure; // @ts-ignore


  var namespace = is_1.isString(name) ? name : '';
  return function wrapWithComponent(WrappedComponent) {
    if (!is_1.isDefined(name)) {
      namespace = getComponentName_1.default(WrappedComponent);
    }

    var displayName = "connected(" + namespace + ")";
    var OuterBaseComponent = pure ? React.PureComponent : React.Component; // Register component internally

    if (!component_1.isComponentNamespaced(WrappedComponent)) {
      component_1.namespaceComponent(namespace)(WrappedComponent);
    }

    var Connect =
    /** @class */
    function (_super) {
      __extends(Connect, _super);

      function Connect(props, context) {
        var _this = _super.call(this, props, context) || this;

        _this.wrappedInstance = null;

        _this.getNamespacedProps = function (contextProps) {
          return utils_1.getConfigProps(contextProps, namespace);
        };

        _this.getMergedClassNameProp = function (contextProps) {
          var namespacedProps = _this.getNamespacedProps(contextProps); // @ts-ignore


          return classNames_1.classNames(namespacedProps.className, _this.props.className);
        };

        _this.getMergedStyleProp = function (contextProps) {
          var namespacedProps = _this.getNamespacedProps(contextProps);

          var style = _this.props.style; // @ts-ignore

          if (namespacedProps.style) {
            style = __assign({}, namespacedProps.style, style);
          }

          return style;
        };

        _this.getMergedProps = function (contextProps) {
          var _a;

          var namespacedProps = _this.getNamespacedProps(contextProps);

          var className = _this.getMergedClassNameProp(contextProps);

          var style = _this.getMergedStyleProp(contextProps);

          return __assign({}, namespacedProps, _this.props, (_a = {
            className: className,
            style: style
          }, _a[utils_1.propProviderDataAttr] = utils_1.getGlobalApp(contextProps), _a.ref = !isStateless(WrappedComponent) ? _this.setWrappedInstance : undefined, _a));
        };

        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
        return _this;
      }

      Connect.prototype.setWrappedInstance = function (ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.render = function () {
        var _this = this;

        return React.createElement(Context_1.default.Consumer, null, function (contextProps) {
          return React.createElement(WrappedComponent, __assign({}, _this.getMergedProps(contextProps)));
        });
      };

      Connect.defaultProps = {
        style: {}
      };
      Connect.displayName = displayName;
      return Connect;
    }(OuterBaseComponent);

    return hoistNonReactStatics_1.default(Connect, WrappedComponent);
  };
}

function isStateless(Component) {
  return typeof Component !== 'string' && !Component.prototype.render;
}

exports.default = propConnect;